/* src/app/forms/produtos/tiktok/tiktok-brand/tiktok-brand.component.scss */
.content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 10px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 20px;
  gap: 10px;
}
.bar-action {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  align-items: end;
}
.pointerMenu {
  cursor: pointer;
}
.table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
.item-content {
  flex: 1;
}
.pointer-menu {
  cursor: pointer;
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=tiktok-brand.component.css.map */
